import { create } from "zustand";
import { api, ApiError } from "@/lib/api.js";

type AuthUser = { id: string; email: string };

type AuthStore = {
  user: AuthUser | null;
  checked: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  checkSession: () => Promise<void>;
};

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  checked: false,

  login: async (email, password) => {
    const res = await api.post<{ ok: boolean; user: AuthUser }>(
      "/api/auth/login/admin",
      { email, password }
    );
    set({ user: res.user });
  },

  logout: async () => {
    await api.post("/api/auth/logout").catch(() => {});
    set({ user: null });
  },

  checkSession: async () => {
    try {
      const res = await api.get<{
        authenticated: boolean;
        user?: AuthUser;
      }>("/api/auth/session");
      set({ user: res.authenticated ? (res.user ?? null) : null, checked: true });
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) {
        set({ user: null, checked: true });
      } else {
        set({ checked: true });
      }
    }
  },
}));
